import {useLocation, useOutletContext} from "react-router-dom";

import {usePermitApplicationForm} from "permitapplication/hooks";
import {
    PermitApplicationReportFormFields,
    PermitApplicationDecisionFormFields,
    PermitForm,
} from "./form";
import {FormCommentsField, FormContainer} from "base/form/components";
import Stack from "@mui/material/Stack";

const PermitApplicationReportStep = () => {
    const {permit, isStepEditable} = useOutletContext();

    const basePath = useLocation();

    const fileFields = ["technical_report"];

    const {handleFormSubmit} = usePermitApplicationForm(permit, basePath, fileFields);

    return (
        <PermitForm permit={permit} onSubmit={handleFormSubmit}>
            <Stack spacing={1}>
                <FormContainer>
                    <PermitApplicationReportFormFields disabled={!isStepEditable} />
                </FormContainer>
                <FormContainer>
                    <PermitApplicationDecisionFormFields disabled={!isStepEditable} />
                </FormContainer>
                <FormContainer>
                    <FormCommentsField
                        rows={5}
                        maxLength={5000}
                        disabled={!isStepEditable}
                    />
                </FormContainer>
            </Stack>
        </PermitForm>
    );
};

export default PermitApplicationReportStep;
